import { helper } from "@ember/component/helper";
import { isHTMLSafe } from "@ember/template";
import { isNone } from "@ember/utils";

const regex = /_+|-+/g;
const replacement = " ";

export function humanize([string]) {
  if (isHTMLSafe(string)) {
    string = string.toString();
  }
  if (isNone(string)) {
    return "";
  }
  const result = string.toLowerCase().replaceAll(regex, replacement);
  return result.charAt(0).toUpperCase() + result.slice(1);
}

export default helper(humanize);
